import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "../../../../contexts/AuthContext";
import { useTeam } from "../../../../contexts/TeamContext";

export interface UseButtonsSectionReturn {
  isTeamMember: boolean;
  userId: string | null;
  isLead: boolean;
  isActive: (path: string) => boolean;
}

export function useButtonsSection(): UseButtonsSectionReturn {
  const location = useLocation();
  const [isTeamMember, setIsTeamMember] = useState(false);
  const { userId } = useAuth();
  const { isLead } = useTeam();

  const isActive = (path: string) => location.pathname === path;

  return {
    isTeamMember,
    userId: userId || null,
    isLead: isLead || false,
    isActive,
  };
}
